import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { TableList } from '../../utils/TableList';
import { MatDialog } from '@angular/material/dialog';
import { ListEntryComponent } from '../list-entry/list-entry.component';
import {
  DeleteListEntryGQL,
  GetLawyerListGQL,
  GetLawyerListQuery,
  ListEntriesTableGQL,
  ListEntriesTableQuery,
  PageLawyerListEntry,
} from '../../../generated/graphql';
import { ActivatedRoute } from '@angular/router';
import { Filter, Pagination } from '../../utils/Pagination';
import { ConfigService } from '../../settings/services/config.service';
import { ListService } from '../services/list.service';
import { PopupErrorComponent } from '../../utils/popup-error/popup-error.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-lists-entries-table',
  templateUrl: './lists-entries-table.component.html',
  styleUrls: ['./lists-entries-table.component.scss'],
})
export class ListsEntriesTableComponent extends TableList implements OnChanges {
  @ViewChild('table') table: Table;

  @Input()
  query: string;

  id: number;
  list: GetLawyerListQuery['list'];
  entries: ListEntriesTableQuery['entries'] = new PageLawyerListEntry();
  uploading = false;

  constructor(
    dialog: MatDialog,
    getList: GetLawyerListGQL,
    route: ActivatedRoute,
    public config: ConfigService,
    private listsService: ListService,
    private snackBar: MatSnackBar,
    private listService: ListService,
    private getService: ListEntriesTableGQL,
    private deleteService: DeleteListEntryGQL
  ) {
    super(ListEntryComponent, dialog);

    this.id = parseInt(route.snapshot.paramMap.get('id'));

    getList.fetch({ id: this.id }).subscribe(s => (this.list = s.data.list));
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateElements();
  }

  ngOnInit(): void {
    this.updateElements();
  }

  delete(id: number) {
    this.deleteService
      .mutate({ list: this.id, lawyer: id })
      .subscribe(s => this.updateElements());
  }

  updateElements() {
    const pagination = new Pagination({ rows: 10000, first: 0, filters: {} });
    pagination.setFilter(new Filter('list.id', this.id, 'equals', null));

    this.getService
      .fetch({ pagination })
      .subscribe(s => {
        this.entries = s.data.entries;
        if (this.table) {
          this.table.filterGlobal(this.query ?? '', 'contains');
        }
      });
  }

  edit(id: number) {
    super.edit(this.list.id);
  }

  import(file: File) {
    this.uploading = true;

    this.listsService.importList(file, this.id).subscribe(s => {
      if (s.errors) {
        this.dialog.open(PopupErrorComponent, {
          width: '90%',
          data: {
            errors: s.errors,
            title: 'Error al importar listado.',
          },
        });
      } else {
        this.snackBar.open('Listados actualizados.', 'Aceptar', {
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });
      }

      this.uploading = false;
      this.updateElements();
    });
  }

  restoreSubstitution(lawyer: number) {
    this.listsService
      .restoreSubstitution(lawyer, this.id)
      .subscribe(s => this.updateElements());
  }

  restoreAssistance(lawyer: number) {
    this.listsService
      .restoreAssistance(lawyer, this.id)
      .subscribe(s => this.updateElements());
  }

  upAssistance(lawyer: number) {
    this.listsService.upAssistance(lawyer, this.id).subscribe(() => this.updateElements());
  }

  upSubstitution(lawyer: number) {
    this.listsService.upSubstitution(lawyer, this.id).subscribe(() => this.updateElements());
  }

  penalizeAssistance(lawyer: number) {
    this.listsService.penalizeAssistance(lawyer, this.id).subscribe(() => this.updateElements());
  }

  penalizeSubstitution(lawyer: number) {
    this.listsService.penalizeSubstitution(lawyer, this.id).subscribe(() => this.updateElements());
  }

  downAssistance(lawyer: number) {
    this.listsService.downAssistance(lawyer, this.id).subscribe(() => this.updateElements());
  }

  downSubstitution(lawyer: number) {
    this.listsService.downSubstitution(lawyer, this.id).subscribe(() => this.updateElements());
  }
}
